import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './CardDetails.css'
import { Button,Card,Row,Col,Container} from 'react-bootstrap';
import Male from '../../Images/male.png'
import Female from '../../Images/female.png'
import Facebook from '../../Images/Facebook.png'
import Twitter from '../../Images/Twitter.png'
import Youtube from '../../Images/YouTube.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCoffee,faShoppingCart,faMapMarkerAlt,faFlag,faFutbol,faMars } from '@fortawesome/free-solid-svg-icons'
 


const CardDetails = () => {
    const {leagueId}=useParams()

    const [info,setInfo]=useState([])
    useEffect(()=>{
        const url=`https://www.thesportsdb.com/api/v1/json/1/lookupleague.php?id=${leagueId}`
        fetch(url)
        .then(res=>res.json())
        .then(data=>{
            setInfo(data.leagues[0])
        })
    },[])

    const imgShow=(gender)=>{
        if(gender==='Female'){
            return Female; 
         }
         else{
             return Male;
         }
    }
   
    return (
        <div className="full-details">
            <div className="cover-img-card d-flex align-items-center justify-content-center">
                <img src={info.strBanner} alt="" />
            </div>
            <Container>
                    <Row className="info-container">
                        <Col className="m-3 p-3">
                            <h2>{info.strLeague}</h2>
                            <h4><FontAwesomeIcon icon={faMapMarkerAlt}/> Founded :{info.dateFirstEvent}</h4>
                            <h4><FontAwesomeIcon icon={faFlag}/> Country :{info.strCountry}</h4>
                            <h4><FontAwesomeIcon icon={faFutbol}/> Sports Type :{info.strSport}</h4>
                            <h4><FontAwesomeIcon icon={faMars}/> Gender :{info.strGender}</h4>
                        </Col>
                        <Col className="img-container">
                            <img src={imgShow(info.strGender)} alt="" />
                        </Col>
                    </Row>
                </Container>
                <Container>
                         <p>{info.strDescriptionEN}</p>     
                </Container>

              <div className="container footer-container icon-container">
                  <a href="https://www.facebook.com">
                  <img className="icon-class m-3 p-3" src={Facebook}>
                  </img>
                  </a>
                  <a href="https://www.youtube.com">
                   <img className="icon-class m-3 p-3" src={Youtube}>
                  </img>
                  </a>
                  <a href="https://www.twitter.com">
                  <img className="icon-class m-3 p-3" src={Twitter}>
                  </img>
                  </a>
              </div>
        </div>
    );
};

export default CardDetails;